import React from 'react';
import TeamIcon from '../../assets/images/account-multiple-custom.png';
import SurgeonIcon from '../../assets/images/doctor-custom.png';
import HospitalIcon from '../../assets/images/hospital-box-outline-custom.png';

function BottomNavigation({ availablePages, onPageSelect }) {
  return (
    <div
      className="fixed-bottom row bg-theme " style={{
        backgroundColor: 'var(--background-gray)',
        padding: '8px',
      }}
    >
      <div className="col-4 text-center">
        <a role="button" tabIndex={0} onClick={() => onPageSelect(availablePages.TEAM)}>
          <img
            className="optimize-icon"
            src={TeamIcon}
            alt="team-icon"
          />
        </a>
      </div>
      <div className="col-4 text-center">
        <a role="button" tabIndex={0} onClick={() => onPageSelect(availablePages.SURGEON)}>
          <img
            className="optimize-icon cursor-pointer"
            src={SurgeonIcon}
            alt="surgeon-icon"
          />
        </a>
      </div>
      <div className="col-4 text-center">
        <a role="button" tabIndex={0} onClick={() => onPageSelect(availablePages.HOSPITAL)}>
          <img
            className="optimize-icon cursor-pointer"
            src={HospitalIcon}
            alt="hospital-icon"
          />
        </a>
      </div>
    </div>
  );
}

export default BottomNavigation;
